declare namespace $ {

	export class $shm_hitalama_entergate_app extends $shm_hitalama_entergate {
		Form( ): $shm_hitalama_entergate_app_form
	}
	
	export class $shm_hitalama_entergate_app_form extends $shm_hitalama_entergate_form {
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map